import _ from 'lodash';

const preDesignedApplications = {
  LANDING_PAGE:      'landing-page',
  POPUP_SIGNUP_FORM: 'popup-signup-form',
};

preDesignedApplications.ALL = _.values(preDesignedApplications);

export default preDesignedApplications;
